import { notFound } from "@tanstack/react-router";

import type { z } from "zod";

export const parameterOrNotFound = <Schema extends z.ZodType>(
  schema: Schema,
  value: unknown,
): z.output<Schema> => {
  const parsed = schema.safeParse(value);
  if (!parsed.success) {
    throw notFound();
  }
  return parsed.data;
};
